import { useCallback } from 'react';
import { useCampaignEditorContext } from '../hooks/useCampaignEditorContext';
import { TargetAudience } from '../CampaignEditorState';

export const useSetTargetAudience = () => {
  const { dispatch } = useCampaignEditorContext();

  return useCallback(
    (targetAudience: TargetAudience, index: number) => {
      dispatch({ type: 'SET_TARGET_AUDIENCE', payload: { ...targetAudience, index } });
    },
    [dispatch],
  );
};

export const useAddNewTargetAudience = () => {
  const { dispatch } = useCampaignEditorContext();

  return useCallback(() => {
    dispatch({ type: 'ADD_TARGET_AUDIENCE' });
  }, [dispatch]);
};

export const useDeleteTargetAudience = () => {
  const { dispatch } = useCampaignEditorContext();

  return useCallback(
    (targetAudience: TargetAudience, index: number) => {
      dispatch({ type: 'DELETE_TARGET_AUDIENCE', payload: { ...targetAudience, index } });
    },
    [dispatch],
  );
};
